import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import RadiusParserPasswordCreate from './containers/RadiusParserPasswordCreate';
import RadiusParserPasswordEdit from './containers/RadiusParserPasswordEdit';
import RadiusParserPasswordView from './containers/RadiusParserPasswordView';
import { SYSTEM_CONFIGURATION_ROUTE, RADIUS_PARSER_PASSWORD, NETWORK } from '../../constants';

interface Props {
}

const RadiusParserPassword: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_PASSWORD}`}>
        <RadiusParserPasswordCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_PASSWORD}/view`}>
        <RadiusParserPasswordView />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_PASSWORD}/edit`}>
        <RadiusParserPasswordEdit />
      </Route>
    </Fragment>
  );
};

export default RadiusParserPassword;
